<div *ngFor="let alert of alerts" class="{{ cssClass(alert) }}">
  <div fxLayout="row" fxLayoutGap="10px" fxFlex>
    <div fxLayoutAlign="start center" fxFlex>
      <mat-icon aria-hidden="false" aria-label="icon-alert">{{ getIcon(alert) }}</mat-icon>
      <span class="alert-message">{{ alert.message }}</span>
    </div>
    <div *ngIf="alert.closeOption" fxLayoutAlign="end center" fxFlex="10">
      <mat-icon matTooltip="Remover" class="icon-close" aria-hidden="false" aria-label="close icon" (click)="removeAlert(alert)"> close </mat-icon>
    </div>
  </div>
</div>
